import { render, staticRenderFns } from "./popularCities.vue?vue&type=template&id=9bf4adda&scoped=true&"
import script from "./popularCities.vue?vue&type=script&lang=js&"
export * from "./popularCities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf4adda",
  null
  
)

export default component.exports